import { render, staticRenderFns } from "./EntryHeaderModules.vue?vue&type=template&id=abfbb048&scoped=true&"
import script from "./EntryHeaderModules.vue?vue&type=script&lang=js&"
export * from "./EntryHeaderModules.vue?vue&type=script&lang=js&"
import style0 from "./EntryHeaderModules.vue?vue&type=style&index=0&id=abfbb048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfbb048",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abfbb048')) {
      api.createRecord('abfbb048', component.options)
    } else {
      api.reload('abfbb048', component.options)
    }
    module.hot.accept("./EntryHeaderModules.vue?vue&type=template&id=abfbb048&scoped=true&", function () {
      api.rerender('abfbb048', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/EntryHeaderModules.vue"
export default component.exports